export const isFirefox = () => /firefox/i.test(navigator.userAgent);
